"use strict";

import config from './config';

export default function(path)
{
	let pathArray = path.split(".");
	return pathArray.reduce((a, b) => a[b], config["production"]);
}
